/** Five9 daily agent-state exports. Reports land each morning, so today is never available yet. */
export const floorCalendar = {
  min: '2026-09-28',
  max: '2026-10-11',
  today: '2026-10-12',
  defaultDate: '2026-10-11',
  refreshedAt: 'Mon, Oct 12 at 6:00 AM',
};
